import React from 'react';
import type { IconProps } from '../types';

export const Microphone = (props: IconProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g
      fill="none"
      fillRule="evenodd"
    >
      <path d="M0 0h24v24H0z" />
      <path
        d="M12 1a4 4 0 0 1 4 4v6a4 4 0 0 1-8 0V5a4 4 0 0 1 4-4zm0 2a2 2 0 0 0-2 2v6a2 2 0 1 0 4 0V5a2 2 0 0 0-2-2zm-7 9a1 1 0 0 1 1 1 6 6 0 1 0 12 0 1 1 0 1 1 2 0 8 8 0 0 1-7 7.938V22h3a1 1 0 1 1 0 2H8a1 1 0 1 1 0-2h3v-2.062A8 8 0 0 1 4 13a1 1 0 0 1 1-1z"
        fill="currentColor"
        fillRule="nonzero"
      />
    </g>
  </svg>
);

export default Microphone;
